var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      class: {
        history: true,
        loading: _vm.loading,
        "has-results": !!_vm.events.length,
        "split-enabled": true
      }
    },
    [
      _c("header", { staticClass: "controls" }, [
        _c("div", { staticClass: "view-format" }, [
          _c("label", { attrs: { for: "format" } }, [_vm._v("View Format")]),
          _vm._v(" "),
          _c("div", { staticClass: "view-formats" }, [
            _c(
              "a",
              {
                staticClass: "compact",
                class: _vm.selectedViewingFormat === "compact" ? "active" : "",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.setFormat("compact")
                  }
                }
              },
              [_vm._v("Compact")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "grid",
                class: _vm.selectedViewingFormat === "grid" ? "active" : "",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.setFormat("grid")
                  }
                }
              },
              [_vm._v("Grid")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "json",
                class: _vm.selectedViewingFormat === "json" ? "active" : "",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.setFormat("json")
                  }
                }
              },
              [_vm._v("JSON")]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "actions" },
          [
            _vm.graphEnabled
              ? _c("feature-flag", { attrs: { name: "workflowGraph" } }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.toggleShowDagGraph()
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.graphView === _vm.GRAPH_VIEW_DAG ? "hide" : "show"
                        ) + " graph"
                      )
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "show-timeline-btn",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.toggleShowTimeline()
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.graphView === _vm.GRAPH_VIEW_TIMELINE ? "hide" : "show"
                  ) + " timeline"
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "export",
                attrs: { href: "#" },
                on: {
                  "~click": function($event) {
                    $event.preventDefault()
                    return _vm.exportHistory.apply(null, arguments)
                  }
                }
              },
              [_vm._v("Export")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      !_vm.showNoResults
        ? _c(
            "Split",
            {
              ref: "splitPanel",
              staticClass: "split-panel",
              class: _vm.graphView === _vm.GRAPH_VIEW_DAG ? "dag-graph" : "",
              attrs: { direction: _vm.splitDirection },
              on: {
                onDrag: _vm.onSplitResize,
                onDragStart: _vm.enableSplitting
              }
            },
            [
              _c(
                "SplitArea",
                {
                  staticClass: "timeline-split",
                  attrs: {
                    "min-size": _vm.splitSizeMinSet[0],
                    size: _vm.splitSizeSet[0]
                  }
                },
                [
                  _vm.graphEnabled &&
                  _vm.graphView === _vm.GRAPH_VIEW_DAG &&
                  _vm.events.length
                    ? _c(
                        "feature-flag",
                        { attrs: { name: "workflowGraph" } },
                        [
                          _c("WorkflowGraph", {
                            staticClass: "tree-view",
                            attrs: {
                              events: _vm.events,
                              isWorkflowRunning: _vm.isWorkflowRunning,
                              "selected-event-id": _vm.eventId
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.graphView === _vm.GRAPH_VIEW_TIMELINE
                    ? _c("timeline", {
                        attrs: {
                          events: _vm.timelineEvents,
                          "selected-event-id": _vm.eventId
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "SplitArea",
                {
                  ref: "viewSplit",
                  staticClass: "view-split",
                  attrs: {
                    "min-size": _vm.splitSizeMinSet[1],
                    size: _vm.splitSizeSet[1]
                  }
                },
                [
                  _c(
                    "section",
                    {
                      directives: [
                        { name: "snapscroll", rawName: "v-snapscroll" }
                      ],
                      ref: "results",
                      staticClass: "results"
                    },
                    [
                      _vm.selectedViewingFormat === "grid" && _vm.showTable
                        ? _c(
                            "div",
                            {
                              staticClass: "table",
                              class: { compact: _vm.compactDetails }
                            },
                            [
                              _c("div", { staticClass: "thead" }, [
                                _c("div", { staticClass: "th col-id" }, [
                                  _vm._v("ID")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "th col-type" },
                                  [
                                    _c("select-input", {
                                      attrs: {
                                        "background-color":
                                          "rgb(248, 248, 249)",
                                        label: "Type",
                                        "min-width": "150px",
                                        options: _vm.eventTypes,
                                        value: _vm.eventType
                                      },
                                      on: { change: _vm.setEventType }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "th col-time" }, [
                                  _vm._v("\n              Time\n            ")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "th col-elapsed-time" },
                                  [
                                    _vm._v(
                                      "\n              Elapsed\n            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "th col-summary" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "summary",
                                      attrs: {
                                        href: _vm.compactDetails ? null : "#"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.setCompactDetails(true)
                                        }
                                      }
                                    },
                                    [_vm._v("Summary")]
                                  ),
                                  _vm._v("\n              /\n              "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "details",
                                      attrs: {
                                        href: _vm.compactDetails ? "#" : null
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.setCompactDetails(false)
                                        }
                                      }
                                    },
                                    [_vm._v("Full Details")]
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "spacer" }),
                              _vm._v(" "),
                              _c("DynamicScroller", {
                                ref: "scrollerGrid",
                                staticStyle: { height: "0px" },
                                attrs: {
                                  "key-field": "eventId",
                                  items: _vm.filteredEvents,
                                  "min-item-size": 38
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var item = ref.item
                                        var index = ref.index
                                        var active = ref.active
                                        return [
                                          _c(
                                            "DynamicScrollerItem",
                                            {
                                              staticClass: "scroller-item",
                                              attrs: {
                                                active: active,
                                                "data-active": active,
                                                "data-index": index,
                                                item: item
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "tr",
                                                  class: {
                                                    active: item.expanded,
                                                    odd: index % 2 === 1
                                                  },
                                                  attrs: {
                                                    "data-event-type":
                                                      item.eventType,
                                                    "data-event-id":
                                                      item.eventId
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.$router.replaceQueryParam(
                                                        "eventId",
                                                        item.eventId
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "td col-id"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.eventId)
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "td col-type"
                                                    },
                                                    [
                                                      _c("highlight-toggle", {
                                                        attrs: {
                                                          "is-highlighted":
                                                            item.details
                                                              .isHighlighted,
                                                          label: item.eventType
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "td col-time"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            item.timeStampDisplay
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "td col-elapsed-time"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            item.timeElapsedDisplay
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "td col-summary"
                                                    },
                                                    [
                                                      _c("event-detail", {
                                                        attrs: {
                                                          event:
                                                            _vm.compactDetails &&
                                                            !item.expanded
                                                              ? item.eventSummary
                                                              : item.eventFullDetails,
                                                          "is-highlight-enabled":
                                                            _vm.compactDetails &&
                                                            !item.expanded
                                                              ? false
                                                              : _vm.workflowHistoryEventHighlightListEnabled,
                                                          compact:
                                                            _vm.compactDetails &&
                                                            !item.expanded
                                                        },
                                                        on: {
                                                          onWorkflowHistoryEventParamToggle: function(
                                                            eventParam
                                                          ) {
                                                            return _vm.onWorkflowHistoryEventParamToggle(
                                                              {
                                                                eventParam: eventParam,
                                                                eventType:
                                                                  item.eventType
                                                              }
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  351506654
                                )
                              }),
                              _vm._v(" "),
                              _c("footer-toolbar", {
                                attrs: {
                                  "cluster-name": _vm.clusterName,
                                  "pending-task-count": _vm.pendingTaskCount
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedViewingFormat === "json" &&
                      _vm.events.length < 90
                        ? _c(
                            "prism",
                            {
                              staticClass: "json",
                              attrs: { language: "json" }
                            },
                            [
                              _vm._v(
                                _vm._s(JSON.stringify(_vm.events, null, 2))
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedViewingFormat === "json" &&
                      _vm.events.length >= 90
                        ? _c("pre", { staticClass: "json" }, [
                            _vm._v(_vm._s(JSON.stringify(_vm.events, null, 2)))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedViewingFormat === "compact"
                        ? _c(
                            "div",
                            { staticClass: "compact-view" },
                            [
                              _c("RecycleScroller", {
                                ref: "scrollerCompact",
                                staticClass: "scroller-compact",
                                staticStyle: { height: "0px" },
                                attrs: {
                                  "key-field": "id",
                                  items: _vm.timelineEvents,
                                  "item-size": 70
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var item = ref.item
                                        return [
                                          _c(
                                            "div",
                                            {
                                              class:
                                                "timeline-event " +
                                                (item.className || "") +
                                                " " +
                                                (item ===
                                                _vm.selectedTimelineEvent
                                                  ? " vis-selected"
                                                  : ""),
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.selectTimelineEvent(
                                                    item
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "event-title" },
                                                [_vm._v(_vm._s(item.content))]
                                              ),
                                              _vm._v(" "),
                                              _c("detail-list", {
                                                attrs: {
                                                  compact: true,
                                                  "is-highlight-enabled": false,
                                                  item: item.details,
                                                  title: item.content
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2024664522
                                )
                              }),
                              _vm._v(" "),
                              _vm.selectedTimelineEvent
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "selected-event-detail",
                                      class: {
                                        active: !!_vm.selectedTimelineEvent
                                      }
                                    },
                                    [
                                      _c("a", {
                                        staticClass: "close",
                                        attrs: { href: "#" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.deselectEvent.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      !_vm.selectedTimelineEvent.titleLink
                                        ? _c(
                                            "span",
                                            { staticClass: "event-title" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.selectedTimelineEvent
                                                    .content
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedTimelineEvent.titleLink
                                        ? _c(
                                            "router-link",
                                            {
                                              staticClass: "event-title",
                                              attrs: {
                                                to:
                                                  _vm.selectedTimelineEvent
                                                    .titleLink
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.selectedTimelineEvent
                                                    .content
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("detail-list", {
                                        staticClass: "timeline-details",
                                        attrs: {
                                          "is-highlight-enabled": false,
                                          item:
                                            _vm.selectedTimelineEvent.details,
                                          title:
                                            _vm.selectedTimelineEvent.content
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "event-tabs" },
                                        [
                                          _c("span", [_vm._v("Events")]),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.selectedTimelineEvent.eventIds,
                                            function(eid) {
                                              return _c(
                                                "a",
                                                {
                                                  key: eid,
                                                  class:
                                                    "event" +
                                                    (_vm.eventId === eid
                                                      ? " active"
                                                      : ""),
                                                  attrs: {
                                                    href: "#",
                                                    "data-event-id": eid
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.$router.replaceQueryParam(
                                                        "eventId",
                                                        eid
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("highlight-toggle", {
                                                    attrs: {
                                                      "is-highlighted": _vm.events.find(
                                                        function(event) {
                                                          return (
                                                            event.eventId ===
                                                            eid
                                                          )
                                                        }
                                                      ).details.isHighlighted,
                                                      label: _vm.events.find(
                                                        function(event) {
                                                          return (
                                                            event.eventId ===
                                                            eid
                                                          )
                                                        }
                                                      ).eventType
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c("detail-list", {
                                        staticClass: "event-detail",
                                        attrs: {
                                          "is-highlight-enabled":
                                            _vm.workflowHistoryEventHighlightListEnabled,
                                          item: _vm.selectedEventDetails,
                                          title:
                                            _vm.selectedTimelineEvent.content +
                                            " - " +
                                            _vm.selectedEvent.eventType
                                        },
                                        on: {
                                          onWorkflowHistoryEventParamToggle: function(
                                            eventParam
                                          ) {
                                            return _vm.onWorkflowHistoryEventParamToggle(
                                              {
                                                eventParam: eventParam,
                                                eventType:
                                                  _vm.selectedEvent.eventType
                                              }
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showNoResults
        ? _c("span", { staticClass: "no-results" }, [_vm._v("No Results")])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bdf630ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdf630ca","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/containers/workflow-history/component.vue
// module id = 1662
// module chunks = 0